import Modal from 'components/Modal';
import styles from '../../RouteHistory.module.scss';
import ListWrapper from 'components/ListWrapper';
import FormGroup from 'components/FormGroup';
import {Controller, useForm} from 'react-hook-form';
import {
  GooglePlaceAutoComplete,
  TypeGooglePlaceDetail,
} from 'components/GooglePlaceAutoComplete';
import TextField from 'components/TextField';
import {Key, useEffect, useState} from 'react';
import MapPreview from 'components/MapPreview';
import Button from 'components/Button';
import {Address, createAddress} from 'types';
import Typography from 'components/Typography';
import {get} from 'lodash';
import ArrowIcon from 'pages/UserForm/UserAddresses/ArrowIcon';

type NewAddressForm = Omit<createAddress, 'label'>;

type Props = {
  isShowModal: boolean;
  onChangeAddress: (addressId: number) => void;
  options: Address[] | undefined;
  addressIsUpdating: boolean;
  onClose: () => void;
  onCreateNewAddress: (address: createAddress, close: () => void) => void;
  defaultCheckedAddressId: number;
};

function NewAddressModal({
  isShowModal,
  onChangeAddress,
  options,
  addressIsUpdating,
  onClose,
  onCreateNewAddress,
  defaultCheckedAddressId,
}: Props) {
  const {control, setValue, reset, handleSubmit} = useForm<NewAddressForm>();
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [deliveryAddressId, setDeliveryAddressId] = useState(
    defaultCheckedAddressId
  );
  const [location, setLocation] = useState({
    latitude: 40.7596958,
    longitude: -73.9650045,
  });
  useEffect(() => {
    if (!!defaultCheckedAddressId && defaultCheckedAddressId > 0) {
      setDeliveryAddressId(defaultCheckedAddressId);
    }
  }, [defaultCheckedAddressId]);
  const onSelectPlace = (placeDetail: TypeGooglePlaceDetail) => {
    setValue('latitude', placeDetail.lat);
    setValue('longitude', placeDetail.lon);
    setTimeout(() => {
      setLocation({latitude: placeDetail.lat, longitude: placeDetail.lon});
    }, 300);
    setValue('zipcode', placeDetail.zipcode);
    setValue('address_line_1', placeDetail.addressLine1);
    setValue('city', placeDetail.city);
    setValue('state', placeDetail.state);
  };

  const handleModalClose = () => {
    setShowAddressForm(false);
    reset();
    setDeliveryAddressId(0);
    onClose();
  };
  return (
    <Modal
      isOpen={isShowModal}
      className={styles.list_wrapper}
      onClose={handleModalClose}
      onRequestClose={handleModalClose}
    >
      <div className={styles.list_innerContainer}>
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Select Delivery Address:
        </Typography>
        <div className={styles.optionWrapper}>
          {options?.map((item: Address, index: Key | null | undefined) => {
            return (
              <label key={index} className={styles.container}>
                <input
                  type="radio"
                  name="radio"
                  defaultChecked={defaultCheckedAddressId === item.id}
                  onClick={() => setDeliveryAddressId(item.id)}
                />
                <span className={styles.radioButtonText}>
                  {get(item, 'display_address', '')}
                </span>
                {!get(item, 'is_valid', true) && (
                  <span className={styles.wrongAddress}>issue</span>
                )}
              </label>
            );
          })}
        </div>
        <div
          onClick={() => setShowAddressForm((pr) => !pr)}
          className={styles.addAddress}
        >
          <p>+ Add address</p>
          <ArrowIcon
            className={
              showAddressForm ? styles.icon_rotated : styles.arror_icon
            }
          />
        </div>
        {showAddressForm && (
          <ListWrapper
            style={{
              marginTop: 10,
              paddingLeft: 20,
              paddingRight: 20,
              paddingBottom: 15,
            }}
          >
            <FormGroup>
              <Controller
                name="city"
                control={control}
                rules={{required: 'Please, Select the address'}}
                render={({field, fieldState}) => (
                  <GooglePlaceAutoComplete
                    label="Your address"
                    placeholder="Address"
                    onSelectPlace={onSelectPlace}
                    error={fieldState.error?.message}
                  />
                )}
              />
              <Controller
                name="unit_address"
                control={control}
                render={({field, fieldState}) => (
                  <TextField
                    label="Unit number"
                    wrapperClass={styles.googleInput}
                    placeholder="Enter unit number"
                    hasError={false}
                    onChange={field.onChange}
                    error={fieldState.error?.message}
                  />
                )}
              />
            </FormGroup>
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: 20,
              }}
            >
              {!!location.latitude && (
                <MapPreview
                  zoom={15}
                  onDrag={(location) => {
                    setValue('latitude', location.lat);
                    setValue('longitude', location.lon);
                  }}
                  center={[location.latitude, location.longitude]}
                />
              )}
            </div>

            <div className={styles.actions}>
              <Button
                type="submit"
                onClick={handleSubmit((data) =>
                  onCreateNewAddress(data, () => setShowAddressForm(false))
                )}
                color="green"
              >
                Add
              </Button>
            </div>
          </ListWrapper>
        )}
        <div className={styles.actions}>
          <Button
            type="submit"
            color="green"
            size="md"
            loading={addressIsUpdating}
            onClick={() => onChangeAddress(deliveryAddressId)}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default NewAddressModal;
